import { Box, Checkbox, CircularProgress, Grid, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import React, { useEffect, useState } from "react";

import API from "../../actions";

import { Close } from "@material-ui/icons";

import "react-day-picker/lib/style.css";
import { useSelector } from "react-redux";
import { formatDate, getInvoiceNumbertext } from "../Invoice/Invoice.js";

export const SaveMergedInvoiceDialog = ({
    selectedBookigIds,
    setSelectedBookingIds,
    clientId,
    selectedToDate,
    selectedFromDate,
    alreadySelectedInvoices,
    setAlreadySelectedInvoices,
    oldInvoiceId,
    setOldInvoiceId,
    setOpenMergeInvoice,
    setKey,
    setSelectedToDate,
    setSelectedFromDate
}) => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);

    const getInovices = async () => {
        setLoading(true);
        const invoicesData = await API.getInvoicesByBookingIds(selectedBookigIds);
        setLoading(false);
        setInvoices(invoicesData);
    };

    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        getInovices();
    }, []);

    const therapist = useSelector(state => state.data.therapist);

    const [selectedInvoicesForMerge, setSelectedInovicesForMerge] = useState([]);

    useEffect(() => {
        setSelectedInovicesForMerge(invoices.filter(i => alreadySelectedInvoices.includes(getInvoiceNumbertext(i))));
        // setSelectedInovicesForMerge(alreadySelectedInvoices);
    }, [alreadySelectedInvoices, invoices]);

    const handleSelectInvoice = invoice => {
        if (selectedInvoicesForMerge.map(i => i.id).includes(invoice.id)) {
            setSelectedInovicesForMerge(selectedInvoicesForMerge.filter(inv => inv.id !== invoice.id));
        } else {
            setSelectedInovicesForMerge([...selectedInvoicesForMerge, invoice]);
        }
    };

    const closeModal = () => {
        setSelectedBookingIds([]);
        setAlreadySelectedInvoices([]);
        setOpenMergeInvoice(false);
        setSelectedToDate();
        setSelectedFromDate();
    };

    const onSave = async () => {
        setSubmitLoading(true);

        const lastImage = selectedInvoicesForMerge.map(i => JSON.parse(i.image));

        const _company = await API.getCompany(therapist.companyId);
        const _cvr = await API.getCvrFromNumber(_company.CVR);
        const calcInvoiceNumber = async _cvr => {
            if (!_cvr) return;

            let cvrCount = _cvr.count;

            const curYear = new Date().getFullYear().toString().substr(-2);
            const lastCvrYear = new Date(_cvr.updatedAt).getFullYear().toString().substr(-2);
            if (lastCvrYear !== curYear) {
                cvrCount = 0;
            }

            return cvrCount;
        };
        const invoiceNumber = await calcInvoiceNumber(_cvr);

        if (!oldInvoiceId) {
            await API.addInvoice(invoiceNumber + 1, null, JSON.stringify(lastImage), true, clientId);

            await API.setCvrCounter(_company.CVR, invoiceNumber + 1);
        } else {
            await API.updateInvoice(oldInvoiceId, JSON.stringify(lastImage));
        }
        setSubmitLoading(false);
        setSelectedBookingIds([]);
        setAlreadySelectedInvoices([]);
        setOldInvoiceId();
        setOpenMergeInvoice(false);
        setKey(Math.random() * 1000);
    };
    const onClose = e => {
        e.stopPropagation();
        setSelectedBookingIds([]);
        setOpenMergeInvoice(true);
    };

    return (
        <Dialog
            open={true}
            onClose={() => {}}
            fullWidth
            PaperProps={{
                style: {
                    width: "100%",
                    minHeight: "350px",
                    borderRadius: "25px",
                    padding: "40px",
                    maxWidth: "700px",
                    overflowY: "visible",
                    margin: "10px"
                },
                className: "date-picker-popup"
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogContent
                style={{
                    padding: "0px",
                    overflowY: "visible",
                    flex: "initial",
                    minHeight: "150px",
                    "@media screen and (max-width:600px)": {
                        minHeight: "220px"
                    },
                    overflow: "auto"
                }}>
                <Grid onClick={closeModal}>
                    <Close
                        style={{
                            color: "#00000059",
                            position: "absolute",
                            right: "10px",
                            top: "10px",
                            fontSize: "40px",
                            cursor: "pointer"
                        }}
                        className="close-icon"
                    />
                </Grid>
                <DialogContentText id="alert-dialog-title">
                    <Typography variant="h5" style={{ color: "black", fontWeight: "bold" }}>
                        Fakturaer fundet i perioden: {formatDate(selectedFromDate)} Til {formatDate(selectedToDate)}
                    </Typography>
                </DialogContentText>

                <DialogContentText id="alert-dialog-description">
                    <Typography variant="subtitle2" style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                        Vælg de fakturaer du vil inkludere i din samlet opgørelse
                    </Typography>
                </DialogContentText>
                {loading && (
                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "200px"
                        }}>
                        <CircularProgress />
                    </Box>
                )}
                {invoices.map((i, index) => (
                    <Box
                        key={index}
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 2,
                            padding: "5px",
                            border: "1px solid #EAEAEA",
                            borderTop: index === 0 ? "1px solid #EAEAEA" : "none",
                            background: "#FAFAFA",
                            borderTopLeftRadius: index === 0 ? "10px" : "0px",
                            borderTopRightRadius: index === 0 ? "10px" : "0px",
                            borderBottomLeftRadius: index === invoices.length - 1 ? "10px" : "0px",
                            borderBottomRightRadius: index === invoices.length - 1 ? "10px" : "0px"
                        }}>
                        <Checkbox
                            color="primary"
                            checked={selectedInvoicesForMerge.map(a => a.id).includes(i.id)}
                            onChange={() => handleSelectInvoice(i)}
                        />
                        <Typography
                            style={{
                                padding: "10px 0px 10px 0px",
                                color: "#4d5ccc"
                            }}>
                            faktura #{getInvoiceNumbertext(i)}
                        </Typography>
                    </Box>
                ))}
            </DialogContent>
            <DialogActions style={{ justifyContent: "flex-start", paddingLeft: "0px" }}>
                <Button
                    disabled={selectedInvoicesForMerge.length === 0 || submitLoading}
                    onClick={() => {
                        onSave();
                    }}
                    color="primary"
                    variant="contained">
                    {oldInvoiceId ? "Opdater valgte fakturaer" : "Vælg fakturaer"}
                    {submitLoading && (
                        <CircularProgress color="secondary" size={"20px"} style={{ marginLeft: "10px" }} />
                    )}
                </Button>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Vælg anden tidsperiode
                </Button>
            </DialogActions>
        </Dialog>
    );
};
